import { useLocalObservable } from 'mobx-react-lite';

import { IImageLoadHandlerParams } from '@gem/components';

import Tasks from 'APP/Tasks';
import { TAvatarBackgroundColorIndex } from 'APP/components/Avatar/Avatar';
import { ImageCropperPopup } from 'APP/main/PopupManager/Popups/ImageCropperPopup/ImageCropperPopup';
import Entities from 'STORE';

export interface IWorkspaceFormData {
  name: string;
  description: string;
  avatarUrl: string;
}

interface IEditWorkspaceFormPresenter {
  defaultValues: IWorkspaceFormData;
  avatarTitle: string;
  avatarColorIndex: TAvatarBackgroundColorIndex;
  onImageLoad(params: IImageLoadHandlerParams): void;
}

export function useEditWorkspaceFormPresenter(): IEditWorkspaceFormPresenter {
  return useLocalObservable<IEditWorkspaceFormPresenter>(() => ({
    defaultValues: {
      name: Entities.workspace.name,
      description: Entities.workspace.description,
      avatarUrl: Entities.workspace.avatarUrl || '',
    },

    get avatarTitle(): string {
      return Entities.workspace.name;
    },

    get avatarColorIndex(): TAvatarBackgroundColorIndex {
      return Entities.workspace.avatarColorIndex;
    },

    onImageLoad(params: IImageLoadHandlerParams): void {
      Tasks.app.openPopup(ImageCropperPopup, { params });
    },
  }));
}
